export default __webpack_public_path__ + "static/media/arrow_ff.caef1841.svg";